import React from "react";

const TableTrPopup = ({productKey, productType, isSpecial, isSpecialProduct, children}) => {
    const dataSpecial = (isSpecial || isSpecialProduct) ? '1' : '0';

    return (
        <tr
            className="table_popup"
            data-product-id={productKey}
            data-product-type-id={productType}
            data-special={dataSpecial}
        >
            {children}
        </tr>
    )
}

export default TableTrPopup;
